import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import {
  getLocationList,
  deleteLocation,
  changeStatus,
  resetComponentStore,
} from "actions/admin/location";
import * as Constants from "constants/index";
import DataTable from "react-data-table-component";

import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Input,
  FormGroup,
  CardHeader,
} from "reactstrap";
import Spinner from "views/components/Spinner";
import styled from "styled-components";
import { FaAngleDown, FaAngleUp, FaPencilAlt, FaTrash } from "react-icons/fa";

const Stack = styled.div`
  display: flex;
  flex-direction: ${(props) => props.direction || "row"};
  align-items: ${(props) => props.alignItems || "initial"};
  -webkit-box-align: center;
  & > div:not(:first-child) {
    margin: 0px;
    margin-left: ${(props) =>
      props.direction !== "column" ? (props.gap || 1) * 8 + "px" : "0px"};
  }
`;

const LocationList = ({
  getLocationList,
  deleteLocation,
  history,
  locationList: { data, count, page },
  sortingParams,
  changeStatus,
  performDelete,
  loading,
  loadingListData,
  resetComponentStore,
}) => {
  const initialSortingParams = {
    limit: 10,
    page: 1,
    orderBy: "updated_at",
    ascending: "desc",
    query: "",
    filters: [],
  };
  const [locationParams, setLocationParams] = useState(initialSortingParams);
  const [onlyOnce, setOnce] = useState(true);
  const [filterOpen, setFilterOpen] = useState(true);

  let delayTimer;

  const columns = [
    {
      name: "Title",
      width: "220px",
      sortable: true,
      selector: (row) => row.location.short_name,
    },
    {
      name: "Image",
      width: "150px",
      selector: (row) => row.image,
      format: (cellContent, row) => (
        <img
          src={
            process.env.REACT_APP_SERVER_URL +
            "/documents/location/" +
            cellContent.image
          }
          width="60px"
          height="60px"
        />
      ),
    },
    {
      name: "Description",
      width: "450px",
      sortable: true,
      selector: (row) => row.description,
      format: (cellContent, row) => (
        <span dangerouslySetInnerHTML={{ __html: cellContent.description }} />
      ),
    },
    {
      name: "Updated At",
      width: "180px",
      sortable: true,
      selector: (row) => row.updatedAt,
      // headerSortingStyle,
      format: (cellContent, row) => moment(cellContent.updatedAt).format("ll"),
    },
    {
      name: "Actions",
      width: "150px",
      selector: (row) => row,
      format: (cellContent, row) => (
        <div>
          <Link
            to={`/home/services/location/${cellContent._id}/edit`}
            title="edit/view"
          >
            <Button
              type="button"
              style={{ marginLeft: 4, color: "white" }}
              size="sm"
              color="success"
            >
              <FaPencilAlt />
            </Button>
          </Link>
          <Button
            type="button"
            size="sm"
            color="danger"
            style={{ marginLeft: 4, color: "white" }}
            onClick={(e) => {
              if (
                window.confirm(
                  `Are you sure you want to delete :\r ${cellContent.location.title}?`
                )
              ) {
                deleteLocation(cellContent._id, history);
              }
            }}
          >
            <FaTrash />
          </Button>
        </div>
      ),
    },
  ];

  const handleSearch = (e, onSearch, searchDelay) => {
    clearTimeout(delayTimer);
    const text = e.target.value;
    delayTimer = setTimeout(() => {
      onSearch(text);
    }, searchDelay);
  };

  const defaultSorted = [
    {
      dataField: "created_at",
      order: "desc",
    },
  ];

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <span className="custom-paginator">
      <span>Records per page: </span>
      <UncontrolledDropdown tag="span">
        <DropdownToggle caret className="dropdown-btn-col-w dropdown-p-28">
          {currSizePerPage}
        </DropdownToggle>
        <DropdownMenu>
          {options.map((option) => (
            <DropdownItem
              tag="li"
              key={option.text}
              onMouseDown={(e) => {
                e.preventDefault();
                onSizePerPageChange(option.page);
              }}
            >
              {option.text}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </UncontrolledDropdown>
    </span>
  );

  const options = {
    page: parseInt(locationParams.page),
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page

    showTotal: true,
    paginationTotalRenderer: customTotal,
    totalSize: count,
    sizePerPageRenderer,
    //sizePerPageOptionRenderer,
    sizePerPageList: [
      {
        text: Constants.DEFAULT_PAGE_SIZE,
        value: Constants.DEFAULT_PAGE_SIZE,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "All",
        value: count,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, searchText, sortField, sortOrder }
  ) => {
    const params = {
      page: type === "search" ? 1 : page || 1,
      limit: sizePerPage,
      orderBy: sortField,
      ascending: sortOrder,
      query: type === "search" ? searchText : locationParams.query,
    };
    //console.log(params);
    // getLocationList(params);
    setLocationParams((param) => ({ ...param, ...params }));
  };
  useEffect(() => {
    let subscribe = true;
    let updateTimer;
    const asyncParams = async () => {
      try {
        if (subscribe) {
          if (onlyOnce) {
            resetComponentStore();
            setOnce(false);
          }
          getLocationList(locationParams);
          // updateTimer = setInterval(function() {
          //   getLocationList(locationParams);
          // }, process.env.REACT_APP_UPDATE_LIST_TIMER);
        }
      } catch (err) {
        // throw err;
      }
    };
    asyncParams();
    return () => {
      subscribe = false;
      clearInterval(updateTimer);
    };
  }, [getLocationList, locationParams, resetComponentStore, onlyOnce]);

  useEffect(() => {
    /**
     * Due to asynchronous behavior it is possible that we are dealing with
     * Old value using setState({...params, propery:value });
     * So, to eliminate this situation we are doing function update such as below
     */
    let subscribe = true;
    const asyncParams = async () => {
      if (subscribe) {
        performDelete &&
          setLocationParams((params) => ({
            ...params,
            ...sortingParams,
            page: parseInt(page),
          }));
      }
    };
    asyncParams();
    return () => {
      subscribe = false;
    };
  }, [page, performDelete, sortingParams]);

  const onSearch = (text) => {
    handleTableChange("search", {
      searchText: text,
      sizePerPage: locationParams.limit,
      sortOrder: locationParams.ascending,
    });
  };
  const handleSort = (column, sortDirection) => {
    const orderBy = column.field;
    setLocationParams((prevParams) => ({
      ...prevParams,
      orderBy,
      ascending: sortDirection,
    }));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLocationParams((prevParams) => ({
      ...prevParams,
      limit: newPerPage,
      page,
    }));
  };

  const handlePageChange = async (page) => {
    setLocationParams((prevParams) => ({ ...prevParams, page }));
  };
  return loading ? (
    <Spinner />
  ) : (
    <div className="animated fadeIn" style={{ marginTop: "5%" }}>
      <Row>
        <Col>
          <Card>
            <CardHeader>
              <Stack
                alignItems="center"
                style={{ justifyContent: "space-between" }}
              >
                <div>
                  <h2>Location List</h2>
                </div>
                <div className="add-button-div">
                  <Link to="/home/services/location/create" title="create">
                    <Button color="primary" size="sm">
                      <i className="fa fa-plus"></i> Add New Location
                    </Button>
                  </Link>
                </div>
              </Stack>
            </CardHeader>
            <CardBody>
              {/*<div className="add-button-div border-bottom">
                 <div
                  className="filters-row"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <h5>Filters</h5>
                  </div>
                  <div onClick={() => setFilterOpen(!filterOpen)}>
                    {filterOpen ? (
                      <FaAngleUp
                        style={{
                          height: 35,
                          marginRight: 15,
                          cursor: "pointer",
                        }}
                      />
                    ) : (
                      <FaAngleDown
                        style={{
                          height: 35,
                          marginRight: 15,
                          cursor: "pointer",
                        }}
                      />
                    )}
                  </div>
                </div> 
              </div>*/}
              <DataTable
                columns={columns}
                data={data}
                // subHeader={filterOpen}
                progressPending={loadingListData}
                pagination
                paginationServer
                onSort={handleSort}
                sortServer
                paginationTotalRows={count}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

LocationList.propTypes = {
  getLocationList: PropTypes.func.isRequired,
  deleteLocation: PropTypes.func.isRequired,
  changeStatus: PropTypes.func.isRequired,
  locationList: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  sortingParams: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  locationList: state.location.locationList,
  loading: state.location.loadingLocationList,
  sortingParams: state.location.sortingParams,
  performDelete: state.location.performDelete,
  loadingListData: state.location.loadingListData,
});

export default connect(mapStateToProps, {
  getLocationList,
  deleteLocation,
  changeStatus,
  resetComponentStore,
})(LocationList);
